import { AuthPage } from 'app/modules/auth';
import JobFairAuthComponent from 'app/modules/job-seeker/JobfairAuth';
import Home from 'app/modules/public/Home';
import SponsorClientInvite from 'app/modules/public/SponsorClientInvite';
import SponsorView from 'app/modules/public/SponsorView';
import { Redirect, Route, Switch } from 'react-router-dom';

export function PublicRoutes () {
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];

  return (
    <>
      {subdomain != null && subdomain !== 'www' && hostname !== 'localhost'
        ? (
          <Switch>
            <Route path='/client-invite' render={() => <SponsorClientInvite subdomain={subdomain} />} />
            <Route path='/jobfairs' render={() => <SponsorView subdomain={subdomain} />} />
            <Route path='/home' component={Home} />
            <Redirect to='/jobfairs' />
          </Switch>
          )
        : (
          <Switch>
            <Route path='/auth' component={AuthPage} />
            <Route path='/home' component={Home} />
            <Route path='/job-seeker/organizations/:orgId/jobfairs/:jobFairId' render={() => <JobFairAuthComponent />} />
            <Redirect to='/auth' />
          </Switch>
          )
      }
    </>
  );
}
